/**
 * i18n : dictionnaires + helpers.
 *
 * Séparé du contexte React pour être importable depuis n'importe où
 * (intercepteurs axios, service worker, ErrorBoundary, etc.).
 *
 * Sync du _lang courant : appelé par I18nProvider dans son useEffect.
 */

export const dict = {
  fr: {
    // nav (labels de sections + entrées)
    dashboard: "Tableau de bord", clients: "Clients", products: "Catalogue", orders: "Commandes",
    tours: "Plans de tournée", tournee: "Ma tournée",
    reports: "Rapports", visit: "Visite",
    deals: "Opportunités",
    connectors: "Intégrations", settings: "Paramètres",
    users: "Membres", payments: "Paiements et relances", privacy: "Confidentialité",
    costs: "Coûts et marges", reconciliation: "Rapprochement bancaire",
    new_visit: "Visite", org_settings: "Paramètres org.", billing: "Abonnement",
    livreur: "Livraison", team: "Mon équipe", qr_labels: "Étiquettes QR",
    portfolios: "Portefeuilles", approvals: "Validations", pwa_status: "Diagnostic mobile",
    prospecting: "Prospection",
    sources: "Sources", permissions: "Permissions",
    stock: "Stock", containers: "Contenants", scan: "Scanner", drm: "DRM",
    documents: "Documents commerciaux", pack_legal: "Pack légal (CGV, RIB…)",
    // sections navigation desktop
    section_field: "Terrain", section_sales: "Clients et ventes",
    section_today: "Aujourd'hui",
    section_logistics: "Logistique", section_finance: "Argent",
    section_catalog: "Catalogue & commandes",
    section_documents: "Documents",
    section_stock: "Stock & conformité", section_pilotage: "Pilotage",
    section_growth: "Acquisition", section_admin: "Administration",
    // personnalisation sidebar
    pin_to_today: "Épingler à Aujourd'hui",
    unpin_from_today: "Détacher d'Aujourd'hui",
    reset_section: "Réinitialiser cette section",
    max_pins_reached: "3 épingles utilisateur maximum",
    customize_hint: "Clic droit sur une entrée pour l'épingler · Glisser pour réordonner",
    collapse_sidebar: "Réduire la barre latérale",
    expand_sidebar: "Développer la barre latérale",
    theme: "Thème",
    theme_light: "Clair", theme_dark: "Sombre", theme_sun: "Soleil", theme_system: "Système",
    user_menu: "Menu utilisateur",
    locked_upgrade: "Fonctionnalité incluse dans le forfait {plan}. Cliquez pour découvrir.",
    counter_overdue: "impayés dépassés",
    counter_containers_out: "contenants à retourner",
    counter_pending_signature: "commandes à signer",
    plan_pro: "Pro",
    plan_entreprise: "Entreprise",
    // auth
    welcome: "Bienvenue", login: "Connexion", register: "Créer un compte", logout: "Déconnexion",
    email: "Email", password: "Mot de passe", name: "Nom", role: "Rôle", language: "Langue",
    forgot_password: "Mot de passe oublié ?", back_to_login: "Retour à la connexion",
    request_reset: "Demander une réinitialisation", change_password: "Changer mon mot de passe",
    old_password: "Mot de passe actuel", new_password: "Nouveau mot de passe",
    // common
    add: "Ajouter", save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", edit: "Modifier",
    search: "Rechercher", loading: "Chargement…", confirm: "Confirmer", close: "Fermer",
    // sync
    online: "En ligne", offline: "Hors ligne", syncing: "Synchronisation…", synced: "À jour",
    // KPIs
    revenue: "Chiffre d'affaires", active_clients: "Clients actifs", quick_report: "Rapport 1-clic",
    voice_input: "Saisie vocale", ai_assistant: "Assistant IA", performance: "Performance",
    account_analysis: "Analyse du compte",
    // Paiements
    payment_terms: "Délai contractuel", actual_delay: "Délai réel moyen", gap: "Écart",
    overdue_amount: "Montant en retard", overdue_age: "Ancienneté", bad_payers: "Mauvais payeurs",
    dso: "DSO", dso_evolution: "Évolution mensuelle du DSO", days: "jours", unpaid: "Impayé",
    // RGPD
    export_data: "Exporter les données", delete_data: "Supprimer les données",
    geolocation: "Géolocalisation", audio_retention: "Rétention audio",
    // Coûts
    costs_locked: "Marges désactivées — coûts de revient à valider",
    validate_costs: "Valider les coûts saisis",
    invalidate_costs: "Réinvalider (recalculer)",
    "toast.import_with_errors": " ({n} erreurs)",
    "toast.clients_imported": "{n} clients importés",
    "toast.playbook_executed": "Playbook exécuté : {details}",
    "profile": "Mon profil",
    "org_settings": "Réglages entreprise",
    "billing": "Facturation",
    "team": "Mon équipe",
    // Toasts communs (extraction Lot 3B)
    "toast.login_success": "Connexion réussie",
    "toast.login_invalid": "Identifiants invalides",
    "toast.login_ratelimit": "Trop de tentatives. Réessaie plus tard.",
    "toast.login_network": "Connexion impossible. Vérifie ton réseau et réessaie.",
    "toast.account_created": "Compte créé",
    "toast.register_failed": "Échec de la création du compte",
    "toast.saved": "Enregistré",
    "toast.deleted": "Supprimé",
    "toast.error_generic": "Une erreur est survenue",
    "toast.tour_created": "Tournée créée",
    "toast.tour_add_client": "Ajoutez au moins un client",
    "toast.geocode_ok": "{n} clients géolocalisés",
    "toast.geocode_error": "Erreur géocodage",
    "toast.deal_created": "Opportunité créée",
    "toast.coach_error": "Erreur coach IA",
  
    "toast.client_v1_cree": "Client \"{v1}\" créé",
    "toast.contact_supprime_v1_commandes_v2_vi": "Contact supprimé ({v1} commandes, {v2} visites)",
    "toast.contenant_inconnu": "Contenant inconnu",
    "toast.couche_a_v1_champ_s_mis_a_jour": "Couche A : {v1} champ(s) mis à jour",
    "toast.couche_a_v1_champ_s_remplis_automat": "Couche A : {v1} champ(s) remplis automatiquement",
    "toast.couche_b_indisponible_v1_bascule_su": "Couche B indisponible ({v1}) — bascule sur Couche A",
    "toast.couche_b_v1_champ_s_enrichi_s": "Couche B : {v1} champ(s) enrichi(s)",
    "toast.enrichissement_auto_echoue_v1": "Enrichissement auto échoué : {v1}",
    "toast.erreur": "Erreur",
    "toast.erreur_commande": "Erreur commande",
    "toast.erreur_playbook": "Erreur playbook",
    "toast.import_v1_v2_nouvelles_v3_doublons_": "Import {v1} — {v2} nouvelles / {v3} doublons / {v4} auto-lettrées",
    "toast.lettrage_applique_v1": "Lettrage appliqué ({v1})",
    "toast.lien_invalide_ou_expire": "Lien invalide ou expiré",
    "toast.scan_bodacc_v1_alertes_sur_v2_siren": "Scan BODACC : {v1} alertes sur {v2} SIREN",
    "toast.scan_rappelconso_v1_match_sur_v2_ra": "Scan RappelConso : {v1} match sur {v2} rappels",
    "toast.scan_v1_nouveaux_chr_sur_v2_filtres": "Scan : {v1} nouveaux CHR (sur {v2} filtrés, {v3} annonces BODACC)",
    "toast.source_publique_indisponible": "Source publique indisponible",
    "toast.tva_non_valide_cote_vies": "TVA non valide côté VIES",
    "toast.v1_ajoute": "{v1} ajouté",
    "toast.v1_clients_geolocalises": "{v1} clients géolocalisés",
    "toast.v1_couts_valides_marges_activees": "{v1} coûts validés — marges activées",
    "toast.v1_localise": "{v1} localisé",
    "toast.v1_prospects_trouves_dans_un_rayon_": "{v1} prospects trouvés dans un rayon de {v2} km",
    "toast.v1_televerse_v2_ko": "{v1} téléversé ({v2} Ko)",
    "toast.v1_transcriptions_purgees_retention": "{v1} transcriptions purgées (rétention {v2}j)",
    "toast.v1_v2": "{v1} → {v2}",
    "toast.vies_v1": "VIES ✓ {v1}",
  
    "toast.3_objectifs_proposes_par_l_ia": "3 objectifs proposés par l'IA",
    "toast.8_caracteres_minimum": "8 caractères minimum",
    "toast.bilan_trimestriel_telecharge": "Bilan trimestriel téléchargé",
    "toast.champ_enregistre_verrou_automatique": "Champ enregistré (verrou automatique)",
    "toast.champs_remplis_par_l_ia": "Champs remplis par l'IA",
    "toast.client_ajoute": "Client ajouté",
    "toast.client_et_lignes_requis": "Client et lignes requis",
    "toast.commande_creee": "Commande créée",
    "toast.commande_signature_en_file_synchro_": "Commande + signature en file — synchro auto au retour du réseau",
    "toast.commande_signee": "Commande signée ✓",
    "toast.compte_rendu_enregistre": "Compte-rendu enregistré",
    "toast.conflit_ecarte": "Conflit écarté",
    "toast.contenant_enregistre": "Contenant enregistré",
    "toast.coordonnees_bancaires_enregistrees": "Coordonnées bancaires enregistrées",
    "toast.copie": "Copié",
    "toast.cout_enregistre": "Coût enregistré",
    "toast.couts_reinvalides": "Coûts réinvalidés",
    "toast.date_de_livraison_obligatoire": "Date de livraison obligatoire",
    "toast.date_obligatoire": "Date obligatoire",
    "toast.demande_envoyee_au_gerant": "Demande envoyée au gérant",
    "toast.demande_traitee": "Demande traitée",
    "toast.departements_enregistres": "Départements enregistrés",
    "toast.donnees_de_demo_ajoutees": "Données de démo ajoutées",
    "toast.enregistre_hors_ligne_sera_synchron": "Enregistré hors-ligne — sera synchronisé au retour du réseau",
    "toast.erreur_chargement": "Erreur chargement",
    "toast.erreur_chargement_catalogue": "Erreur chargement catalogue",
    "toast.erreur_chargement_kpis": "Erreur chargement KPIs",
    "toast.erreur_conversion": "Erreur conversion",
    "toast.erreur_ia": "Erreur IA",
    "toast.erreur_import": "Erreur import",
    "toast.erreur_parsing": "Erreur parsing",
    "toast.erreur_scan": "Erreur scan",
    "toast.erreur_seed": "Erreur seed",
    "toast.etablissement_cree": "Établissement créé",
    "toast.evenement_cree": "Événement créé",
    "toast.export_telecharge": "Export téléchargé",
    "toast.extraction_ia_echouee_completez_a_l": "Extraction IA échouée, complétez à la main",
    "toast.formulaire_rempli_par_l_ia": "Formulaire rempli par l'IA",
    "toast.geolocalisation_desactivee_par_l_or": "Géolocalisation désactivée par l'organisation",
    "toast.gps_refuse_impossible": "GPS refusé/impossible",
    "toast.impossible_de_charger_le_playbook": "Impossible de charger le playbook",
    "toast.impossible_de_charger_les_propositi": "Impossible de charger les propositions",
    "toast.introuvable": "Introuvable",
    "toast.les_mots_de_passe_ne_correspondent_": "Les mots de passe ne correspondent pas",
    "toast.lien_copie": "Lien copié",
    "toast.lien_copie_envoyez_le_au_client_par": "Lien copié — envoyez-le au client par SMS/WhatsApp",
    "toast.mot_de_passe_mis_a_jour": "✓ Mot de passe mis à jour",
    "toast.mot_de_passe_temporaire_genere": "Mot de passe temporaire généré",
    "toast.motif_requis": "Motif requis",
    "toast.mouvement_enregistre": "Mouvement enregistré",
    "toast.nom_requis": "Nom requis",
    "toast.note_ajoutee": "Note ajoutée",
    "toast.objectif_fixe": "Objectif fixé",
    "toast.paiement_recu": "Paiement reçu !",
    "toast.panier_vide": "Panier vide",
    "toast.pdf_envoye_a_v1": "PDF envoyé à {v1}",
    "toast.pdf_telecharge": "PDF téléchargé",
    "toast.permissions_enregistrees": "Permissions enregistrées",
    "toast.place_id_delie": "Place ID délié",
    "toast.place_id_lie": "Place ID lié",
    "toast.position_captee": "Position captée",
    "toast.preferences_enregistrees": "Préférences enregistrées",
    "toast.produit_ajoute": "Produit ajouté",
    "toast.prospect_ajoute_au_portefeuille": "Prospect ajouté au portefeuille",
    "toast.prospect_deja_dans_le_portefeuille": "Prospect déjà dans le portefeuille",
    "toast.rapport_exporte": "Rapport exporté",
    "toast.recommande_creee": "Recommande créée",
    "toast.recommande_creee_en_1_clic": "Recommande créée en 1 clic",
    "toast.reglages_sauvegardes": "Réglages sauvegardés",
    "toast.releve_enregistre_1_pour_l_observat": "Relevé enregistré · +1 pour l'observatoire",
    "toast.saisir_un_n_tva": "Saisir un n° TVA",
    "toast.selectionnez_un_client": "Sélectionnez un client",
    "toast.seuils_sauvegardes": "Seuils sauvegardés",
    "toast.signature_client_requise": "Signature client requise",
    "toast.signature_enregistree": "Signature enregistrée",
    "toast.tarif_hecto_sauvegarde": "Tarif hecto sauvegardé",
    "toast.utilisateur_cree": "Utilisateur créé",
    "toast.vies_indisponible": "VIES indisponible",
    "toast.invitation_sent": "Invitation envoyée",
    "toast.invitation_revoked": "Invitation révoquée",
    "toast.password_min_10": "10 caractères minimum",
    "toast.email_required": "E-mail requis",
    "toast.account_activated": "Compte activé en {seconds}s ✓",
    "toast.billing_read_only": "Modification bloquée — abonnement en lecture seule",
    "confirm.revoke_invitation": "Révoquer cette invitation ?",
    // Libellés métier des permissions (page:*, product:*) — utilisés par /pricing
    "feature.page:dashboard": "Tableau de bord",
    "feature.page:clients": "Clients et établissements",
    "feature.page:orders": "Prise de commande",
    "feature.page:products": "Catalogue produits",
    "feature.page:tours": "Tournées",
    "feature.page:visits": "Comptes rendus de visite",
    "feature.page:stock": "Stock et contenants",
    "feature.page:drm": "DRM douane",
    "feature.page:reports": "Rapports et pilotage",
    "feature.page:paiements": "Paiements et relances",
    "feature.page:rapprochement": "Rapprochement bancaire",
    "feature.page:prospection": "Prospection",
    "feature.page:users": "Gestion des utilisateurs",
    "feature.page:integrations": "Intégrations et connecteurs",
    "feature.product:view_cost": "Coûts de revient et marges",
    "feature.ai:coach": "Coach IA (opportunités)",
    "feature.ai:voice": "Assistant vocal IA",
    // Arguments transverses (affichés sur les 3 forfaits)
    "feature.transverse.offline": "Mode hors-ligne complet",
    "feature.transverse.voice": "Dictée vocale terrain",
    // Lot QA — clés manquantes (états vides, boutons, titres)
    "empty.clients": "Aucun client. Cliquez sur « Nouveau client » ou utilisez la saisie vocale.",
    "empty.orders": "Aucune commande",
    "empty.no_data": "Aucune donnée",
    "empty.no_line": "Aucune ligne. Cliquez sur « Ajouter ».",
    "empty.no_stock": "Aucun contenant enregistré.",
    "empty.no_movement": "Aucun mouvement sur produits alcoolisés ce mois-ci.",
    "empty.no_late": "Aucun retard — bravo 🎉",
    "empty.no_reconciliation": "Aucune écriture. Importez un relevé pour commencer.",
    "empty.no_proposition": "Aucune proposition. Vérifiez qu'il existe une facture ouverte correspondante.",
    "empty.no_products": "Aucun produit",
    "new_client": "Nouveau client",
    "new_order": "Nouvelle commande",
    "new_establishment": "Nouvel établissement",
    "import_csv": "Importer CSV",
    "importing": "Import…",
    "loading_ellipsis": "Chargement…",
    "saving_ellipsis": "Enregistrement…",
    "back": "Retour",
    "back_to_containers": "Retour aux contenants",
    "traceability": "Traçabilité",
    "scan_page_title": "Scanner un contenant",
    "scan_help": "QR code ou code-barres. Pointez la caméra vers l'étiquette.",
    "scan_permission_hint": "Aucun accès caméra tant que vous ne cliquez pas ci-dessous.",
    "scan_camera_denied": "Impossible d'accéder à la caméra. Autorisez l'accès ou saisissez le code manuellement.",
    "scan_manual_placeholder": "ID ou code-barres",
    "activate_camera": "Activer la caméra",
    "stop_camera": "Arrêter la caméra",
    "manual_entry": "Saisie manuelle",
    "submit": "Valider",
    "dashboard_greeting": "Bonjour, {name}.",
    "dashboard_glance": "Voici votre journée en un coup d'œil.",
    "dashboard_overview": "Vue d'ensemble",
    "dashboard_load_demo": "Charger des données démo",
    "kpi_revenue": "Chiffre d'affaires",
    "kpi_orders": "Commandes",
    "kpi_active_clients": "Clients actifs",
    "kpi_vip_clients": "Clients VIP",
    "revenue_evolution": "Évolution du CA",
    "last_6_months": "6 derniers mois",
    "top_products": "Top produits",
    "portfolio": "Portefeuille",
    "sales": "Ventes",
    "settlement": "Trésorerie",
    "warehouse_field": "Entrepôt & terrain",
    "stock_state": "État du stock",
    "compliance_tax": "Conformité fiscale",
    "drm_page_title": "DRM — Déclaration Récapitulative Mensuelle",
    "drm_help": "Aide à la préparation. À déclarer sur portailpro.douanes.gouv.fr.",
    "automations": "Automatisations",
    "preferences": "Préférences",
    "auto_reminders": "Relances automatiques",
    "search_client_placeholder": "Rechercher un client, ville, contact…",
    "search_reconciliation_placeholder": "Filtrer libellé, contrepartie, montant…",
    "column.name": "Nom",
    "column.type": "Type",
    "column.city": "Ville",
    "column.contact": "Contact",
    "column.status": "Statut",
    "column.health": "Santé",
    "column.client": "Client",
    "column.date": "Date",
    "column.lines": "Lignes",
    "column.total": "Total",
    "column.actions": "Actions",
    "column.product": "Produit",
    "column.category": "Catégorie",
    "column.degrees": "Deg.",
    "column.in_stock": "En stock",
    "column.at_clients": "Chez clients",
    "column.returns": "Retours",
    "column.empty": "Vides",
    "column.volume": "Volume (L)",
    "column.label": "Libellé",
    "column.amount": "Montant",
    "column.counterparty": "Contrepartie",
    "kpi_reconciliation_entries": "Écritures",
    "kpi_to_letter": "À lettrer",
    "kpi_lettered": "Lettrées",
    "kpi_auto_rate": "Taux auto",
    "filter.open": "À lettrer",
    "filter.matched": "Lettrées",
    "filter.partial": "Partielles",
    "filter.all": "Toutes",
    "action.import_statement": "Importer un relevé",
    "action.propositions": "Propositions",
    "reconciliation_help": "Import CSV · CAMT.053 · CFONB 120 — moteur de lettrage à 4 niveaux de confiance",
    "manager_only": "Réservé au manager.",
    "return": "Retour",
    "login_hero_title_line1": "La distribution de boissons,",
    "login_hero_title_line2": "simplifiée.",
    "login_hero_subtitle": "Saisie vocale, hors-ligne, DRM douane, DSO temps réel. Vos commerciaux passent enfin plus de temps sur le terrain.",
    "forgot_hero_title_line1": "Un code à 6 chiffres,",
    "forgot_hero_title_line2": "valable 15 minutes.",
    "forgot_hero_subtitle": "Le code est envoyé par email. Si vous ne le recevez pas, il s'affiche directement à l'écran pour ne jamais vous bloquer.",
    "see_pricing": "Voir les tarifs",
    "navigation": "Navigation",
    "notifications": "Notifications",
    "theme_toggle": "Changer de thème",
    "open_command_palette": "Ouvrir la palette de commandes",
    "search_verb": "Rechercher",
    "bad_payers_help": "Score composite : retard moyen + ancienneté + montant.",
    "low_stock_alert": "Alerte stock bas · {n} produit(s)",
    "others": "autres",
  },
  en: {
    dashboard: "Dashboard", clients: "Clients", products: "Catalog", orders: "Orders",
    tours: "Route plans", tournee: "My route",
    reports: "Reports", visit: "Visit",
    deals: "Opportunities",
    connectors: "Integrations", settings: "Settings",
    users: "Members", payments: "Payments & follow-ups", privacy: "Privacy",
    costs: "Costs & margins", reconciliation: "Bank reconciliation",
    new_visit: "New visit", org_settings: "Org. settings", billing: "Subscription",
    livreur: "Delivery", team: "My team", qr_labels: "QR labels",
    portfolios: "Portfolios", approvals: "Approvals", pwa_status: "Mobile diagnostics",
    prospecting: "Prospecting",
    sources: "Sources", permissions: "Permissions",
    stock: "Stock", containers: "Containers", scan: "Scan", drm: "DRM",
    documents: "Business documents", pack_legal: "Legal pack (T&Cs, IBAN…)",
    section_field: "Field", section_sales: "Customers & sales",
    section_today: "Today",
    section_logistics: "Logistics", section_finance: "Money",
    section_catalog: "Catalog & orders",
    section_documents: "Documents",
    section_stock: "Stock & compliance", section_pilotage: "Steering",
    section_growth: "Acquisition", section_admin: "Admin",
    pin_to_today: "Pin to Today",
    unpin_from_today: "Unpin from Today",
    reset_section: "Reset this section",
    max_pins_reached: "3 user pins max",
    customize_hint: "Right-click an entry to pin it · Drag to reorder",
    collapse_sidebar: "Collapse sidebar",
    expand_sidebar: "Expand sidebar",
    locked_upgrade: "Feature included in the {plan} plan. Click to learn more.",
    counter_overdue: "overdue unpaid",
    counter_containers_out: "containers to return",
    counter_pending_signature: "orders to sign",
    plan_pro: "Pro",
    plan_entreprise: "Enterprise",
    welcome: "Welcome", login: "Sign in", register: "Create account", logout: "Log out",
    email: "Email", password: "Password", name: "Name", role: "Role", language: "Language",
    forgot_password: "Forgot password?", back_to_login: "Back to sign in",
    request_reset: "Request reset", change_password: "Change my password",
    old_password: "Current password", new_password: "New password",
    add: "Add", save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit",
    search: "Search", loading: "Loading…", confirm: "Confirm", close: "Close",
    online: "Online", offline: "Offline", syncing: "Syncing…", synced: "Up to date",
    revenue: "Revenue", active_clients: "Active clients", quick_report: "1-click report",
    voice_input: "Voice input", ai_assistant: "AI assistant", performance: "Performance",
    account_analysis: "Account analysis",
    payment_terms: "Contractual terms", actual_delay: "Actual avg. delay", gap: "Gap",
    overdue_amount: "Overdue amount", overdue_age: "Age", bad_payers: "Bad payers",
    dso: "DSO", dso_evolution: "Monthly DSO trend", days: "days", unpaid: "Unpaid",
    export_data: "Export data", delete_data: "Delete data",
    geolocation: "Geolocation", audio_retention: "Audio retention",
    costs_locked: "Margins disabled — cost prices to validate",
    validate_costs: "Validate entered costs",
    invalidate_costs: "Invalidate (recompute)",
    "toast.import_with_errors": " ({n} errors)",
    "toast.clients_imported": "{n} clients imported",
    "toast.playbook_executed": "Playbook executed: {details}",
    "profile": "My profile",
    "org_settings": "Organisation settings",
    "billing": "Billing",
    "team": "My team",
    "toast.login_success": "Signed in",
    "toast.login_invalid": "Invalid credentials",
    "toast.login_ratelimit": "Too many attempts. Try again later.",
    "toast.login_network": "Connection failed. Check your network and retry.",
    "toast.account_created": "Account created",
    "toast.register_failed": "Sign-up failed",
    "toast.saved": "Saved",
    "toast.deleted": "Deleted",
    "toast.error_generic": "Something went wrong",
    "toast.tour_created": "Route created",
    "toast.tour_add_client": "Add at least one client",
    "toast.geocode_ok": "{n} clients geolocated",
    "toast.geocode_error": "Geocoding error",
    "toast.deal_created": "Opportunity created",
    "toast.coach_error": "AI coach error",
  
    "toast.client_v1_cree": "client \"{v1}\" créé",
    "toast.contact_supprime_v1_commandes_v2_vi": "Contact supprimé ({v1} orders, {v2} visits)",
    "toast.contenant_inconnu": "container inconnu",
    "toast.couche_a_v1_champ_s_mis_a_jour": "Couche A : {v1} field(s) mis à jour",
    "toast.couche_a_v1_champ_s_remplis_automat": "Couche A : {v1} field(s) remplis automatiquement",
    "toast.couche_b_indisponible_v1_bascule_su": "Couche B indisponible ({v1}) — bascule sur Couche A",
    "toast.couche_b_v1_champ_s_enrichi_s": "Couche B : {v1} field(s) enrichi(s)",
    "toast.enrichissement_auto_echoue_v1": "Enrichissement auto échoué : {v1}",
    "toast.erreur": "Error",
    "toast.erreur_commande": "error order",
    "toast.erreur_playbook": "error playbook",
    "toast.import_v1_v2_nouvelles_v3_doublons_": "Import {v1} — {v2} nouvelles / {v3} doublons / {v4} auto-lettrées",
    "toast.lettrage_applique_v1": "Lettrage appliqué ({v1})",
    "toast.lien_invalide_ou_expire": "Lien invalide ou expiré",
    "toast.scan_bodacc_v1_alertes_sur_v2_siren": "scan BODACC : {v1} alerts sur {v2} SIREN",
    "toast.scan_rappelconso_v1_match_sur_v2_ra": "scan RappelConso : {v1} match sur {v2} rappels",
    "toast.scan_v1_nouveaux_chr_sur_v2_filtres": "scan : {v1} nouveaux CHR (sur {v2} filtrés, {v3} annonces BODACC)",
    "toast.source_publique_indisponible": "Source publique indisponible",
    "toast.tva_non_valide_cote_vies": "TVA non valide côté VIES",
    "toast.v1_ajoute": "{v1} ajouté",
    "toast.v1_clients_geolocalises": "{v1} clients géolocalisés",
    "toast.v1_couts_valides_marges_activees": "{v1} costs validés — margins activées",
    "toast.v1_localise": "{v1} localisé",
    "toast.v1_prospects_trouves_dans_un_rayon_": "{v1} prospects found dans un radius de {v2} km",
    "toast.v1_televerse_v2_ko": "{v1} téléversé ({v2} Ko)",
    "toast.v1_transcriptions_purgees_retention": "{v1} transcriptions purgées (rétention {v2}j)",
    "toast.v1_v2": "{v1} → {v2}",
    "toast.vies_v1": "VIES ✓ {v1}",
  
    "toast.3_objectifs_proposes_par_l_ia": "3 goals proposed by AI",
    "toast.8_caracteres_minimum": "8 caractères minimum",
    "toast.bilan_trimestriel_telecharge": "Quarterly review downloaded",
    "toast.champ_enregistre_verrou_automatique": "Field saved (auto-lock)",
    "toast.champs_remplis_par_l_ia": "Fields filled by AI",
    "toast.client_ajoute": "Client added",
    "toast.client_et_lignes_requis": "Client et lignes requis",
    "toast.commande_creee": "Order created",
    "toast.commande_signature_en_file_synchro_": "Order + signature queued — auto-sync when network returns",
    "toast.commande_signee": "order signed ✓",
    "toast.compte_rendu_enregistre": "Report saved",
    "toast.conflit_ecarte": "Conflict dismissed",
    "toast.contenant_enregistre": "Container saved",
    "toast.coordonnees_bancaires_enregistrees": "Bank details saved",
    "toast.copie": "Copied",
    "toast.cout_enregistre": "Cost saved",
    "toast.couts_reinvalides": "Costs invalidated",
    "toast.date_de_livraison_obligatoire": "Delivery date required",
    "toast.date_obligatoire": "Date required",
    "toast.demande_envoyee_au_gerant": "Request sent to manager",
    "toast.demande_traitee": "Request processed",
    "toast.departements_enregistres": "Departments saved",
    "toast.donnees_de_demo_ajoutees": "Demo data added",
    "toast.enregistre_hors_ligne_sera_synchron": "Saved offline — will sync when network returns",
    "toast.erreur_chargement": "Loading error",
    "toast.erreur_chargement_catalogue": "Catalog loading error",
    "toast.erreur_chargement_kpis": "KPI loading error",
    "toast.erreur_conversion": "error conversion",
    "toast.erreur_ia": "AI error",
    "toast.erreur_import": "Import error",
    "toast.erreur_parsing": "Parsing error",
    "toast.erreur_scan": "Scan error",
    "toast.erreur_seed": "Seed error",
    "toast.etablissement_cree": "Establishment created",
    "toast.evenement_cree": "Event created",
    "toast.export_telecharge": "Export downloaded",
    "toast.extraction_ia_echouee_completez_a_l": "AI extraction failed, complete manually",
    "toast.formulaire_rempli_par_l_ia": "Form filled by AI",
    "toast.geolocalisation_desactivee_par_l_or": "Geolocation disabled by organisation",
    "toast.gps_refuse_impossible": "GPS refused/unavailable",
    "toast.impossible_de_charger_le_playbook": "unable de charger le playbook",
    "toast.impossible_de_charger_les_propositi": "Unable to load proposals",
    "toast.introuvable": "Not found",
    "toast.les_mots_de_passe_ne_correspondent_": "Passwords do not match",
    "toast.lien_copie": "Lien copied",
    "toast.lien_copie_envoyez_le_au_client_par": "Lien copied — envoyez-le au client par SMS/WhatsApp",
    "toast.mot_de_passe_mis_a_jour": "✓ password updated",
    "toast.mot_de_passe_temporaire_genere": "Temporary password generated",
    "toast.motif_requis": "Reason required",
    "toast.mouvement_enregistre": "Movement saved",
    "toast.nom_requis": "Name required",
    "toast.note_ajoutee": "Note added",
    "toast.objectif_fixe": "Objectif fixé",
    "toast.paiement_recu": "Paiement reçu !",
    "toast.panier_vide": "Empty cart",
    "toast.pdf_envoye_a_v1": "PDF envoyé à {v1}",
    "toast.pdf_telecharge": "PDF téléchargé",
    "toast.permissions_enregistrees": "Permissions saved",
    "toast.place_id_delie": "Place ID unlinked",
    "toast.place_id_lie": "Place ID linked",
    "toast.position_captee": "Location captured",
    "toast.preferences_enregistrees": "Preferences saved",
    "toast.produit_ajoute": "Product added",
    "toast.prospect_ajoute_au_portefeuille": "Prospect ajouté au portefeuille",
    "toast.prospect_deja_dans_le_portefeuille": "Prospect déjà dans le portefeuille",
    "toast.rapport_exporte": "Report exported",
    "toast.recommande_creee": "Recommande créée",
    "toast.recommande_creee_en_1_clic": "Recommande créée en 1 clic",
    "toast.reglages_sauvegardes": "Settings saved",
    "toast.releve_enregistre_1_pour_l_observat": "Relevé enregistré · +1 pour l'observatoire",
    "toast.saisir_un_n_tva": "Saisir un n° TVA",
    "toast.selectionnez_un_client": "Select a client",
    "toast.seuils_sauvegardes": "Thresholds saved",
    "toast.signature_client_requise": "Client signature required",
    "toast.signature_enregistree": "Signature enregistrée",
    "toast.tarif_hecto_sauvegarde": "Hecto price saved",
    "toast.utilisateur_cree": "User created",
    "toast.vies_indisponible": "VIES indisponible",
    "toast.invitation_sent": "Invitation sent",
    "toast.invitation_revoked": "Invitation revoked",
    "toast.password_min_10": "10 characters minimum",
    "toast.email_required": "Email required",
    "toast.account_activated": "Account activated in {seconds}s ✓",
    "toast.billing_read_only": "Change blocked — subscription in read-only mode",
    "confirm.revoke_invitation": "Revoke this invitation?",
    "feature.page:dashboard": "Dashboard",
    "feature.page:clients": "Clients & venues",
    "feature.page:orders": "Order taking",
    "feature.page:products": "Product catalog",
    "feature.page:tours": "Route plans",
    "feature.page:visits": "Visit reports",
    "feature.page:stock": "Stock & containers",
    "feature.page:drm": "Excise duty (DRM)",
    "feature.page:reports": "Reports & analytics",
    "feature.page:paiements": "Payments & reminders",
    "feature.page:rapprochement": "Bank reconciliation",
    "feature.page:prospection": "Prospecting",
    "feature.page:users": "User management",
    "feature.page:integrations": "Integrations & connectors",
    "feature.product:view_cost": "Cost prices & margins",
    "feature.ai:coach": "AI opportunity coach",
    "feature.ai:voice": "AI voice assistant",
    "feature.transverse.offline": "Full offline mode",
    "feature.transverse.voice": "Field voice dictation",
    // Lot QA — missing keys (empty states, buttons, titles)
    "empty.clients": "No customer yet. Click \"New customer\" or use voice input.",
    "empty.orders": "No order yet",
    "empty.no_data": "No data",
    "empty.no_line": "No line yet. Click \"Add\".",
    "empty.no_stock": "No container recorded.",
    "empty.no_movement": "No movement on alcoholic products this month.",
    "empty.no_late": "No overdue payment — great job 🎉",
    "empty.no_reconciliation": "No entry. Import a statement to start.",
    "empty.no_proposition": "No proposition. Check that a matching open invoice exists.",
    "empty.no_products": "No product",
    "new_client": "New customer",
    "new_order": "New order",
    "new_establishment": "New venue",
    "import_csv": "Import CSV",
    "importing": "Importing…",
    "loading_ellipsis": "Loading…",
    "saving_ellipsis": "Saving…",
    "back": "Back",
    "back_to_containers": "Back to containers",
    "traceability": "Traceability",
    "scan_page_title": "Scan a container",
    "scan_help": "QR code or barcode. Point the camera at the label.",
    "scan_permission_hint": "No camera access until you click below.",
    "scan_camera_denied": "Cannot access the camera. Allow access or type the code manually.",
    "scan_manual_placeholder": "ID or barcode",
    "activate_camera": "Activate the camera",
    "stop_camera": "Stop the camera",
    "manual_entry": "Manual entry",
    "submit": "Submit",
    "dashboard_greeting": "Hi, {name}.",
    "dashboard_glance": "Here is your day at a glance.",
    "dashboard_overview": "Overview",
    "dashboard_load_demo": "Load demo data",
    "kpi_revenue": "Revenue",
    "kpi_orders": "Orders",
    "kpi_active_clients": "Active customers",
    "kpi_vip_clients": "VIP customers",
    "revenue_evolution": "Revenue trend",
    "last_6_months": "Last 6 months",
    "top_products": "Top products",
    "portfolio": "Portfolio",
    "sales": "Sales",
    "settlement": "Cash",
    "warehouse_field": "Warehouse & field",
    "stock_state": "Stock status",
    "compliance_tax": "Tax compliance",
    "drm_page_title": "DRM — Monthly excise declaration",
    "drm_help": "Preparation aid. To be filed on portailpro.douanes.gouv.fr.",
    "automations": "Automations",
    "preferences": "Preferences",
    "auto_reminders": "Auto follow-ups",
    "search_client_placeholder": "Search a customer, city, contact…",
    "search_reconciliation_placeholder": "Filter label, counterparty, amount…",
    "column.name": "Name",
    "column.type": "Type",
    "column.city": "City",
    "column.contact": "Contact",
    "column.status": "Status",
    "column.health": "Health",
    "column.client": "Customer",
    "column.date": "Date",
    "column.lines": "Lines",
    "column.total": "Total",
    "column.actions": "Actions",
    "column.product": "Product",
    "column.category": "Category",
    "column.degrees": "Deg.",
    "column.in_stock": "In stock",
    "column.at_clients": "At customers",
    "column.returns": "Returns",
    "column.empty": "Empties",
    "column.volume": "Volume (L)",
    "column.label": "Label",
    "column.amount": "Amount",
    "column.counterparty": "Counterparty",
    "kpi_reconciliation_entries": "Entries",
    "kpi_to_letter": "To match",
    "kpi_lettered": "Matched",
    "kpi_auto_rate": "Auto rate",
    "filter.open": "To match",
    "filter.matched": "Matched",
    "filter.partial": "Partial",
    "filter.all": "All",
    "action.import_statement": "Import a statement",
    "action.propositions": "Propositions",
    "reconciliation_help": "CSV · CAMT.053 · CFONB 120 import — 4-tier confidence matching engine",
    "manager_only": "Manager only.",
    "return": "Back",
    "login_hero_title_line1": "Beverage distribution,",
    "login_hero_title_line2": "made simple.",
    "login_hero_subtitle": "Voice input, offline-first, excise DRM, real-time DSO. Your sales team finally spends more time in the field.",
    "forgot_hero_title_line1": "A 6-digit code,",
    "forgot_hero_title_line2": "valid for 15 minutes.",
    "forgot_hero_subtitle": "The code is sent by email. If you don't receive it, it also appears on screen so you're never blocked.",
    "see_pricing": "See pricing",
    "navigation": "Navigation",
    "notifications": "Notifications",
    "theme_toggle": "Switch theme",
    "open_command_palette": "Open the command palette",
    "search_verb": "Search",
    "bad_payers_help": "Composite score: average delay + age + amount.",
    "low_stock_alert": "Low-stock alert · {n} product(s)",
    "others": "others",
  },
};

export const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
];

let _lang = "fr";
export function _setModuleLang(l) { if (dict[l]) _lang = l; }
export function getModuleLang() { return _lang; }

/**
 * t(key, params?) — traduction avec fallback FR puis clé.
 * params : dict remplaçant {name} par sa valeur.
 */
export function t(key, params) {
  const v = (dict[_lang] && dict[_lang][key]) || (dict.fr && dict.fr[key]) || key;
  if (!params) return v;
  return v.replace(/\{(\w+)\}/g, (_, k) => (params[k] !== undefined ? String(params[k]) : `{${k}}`));
}
